// extracted by mini-css-extract-plugin
module.exports = {"EditorButton":"EditorButton_EditorButton__m5TCi","EditorButtonActive":"EditorButton_EditorButtonActive__dgr6A EditorButton_EditorButton__m5TCi"};